export default "Optimisez vos achats d'énergie HTA/HTB. Courtier indépendant des fournisseurs d'énergie, audit TURPE/ATRD, comparaison de toutes les offres. Référent dédié grands comptes.";
